<template>
  <v-row>
    <!-- CATEGORY -->
    <v-col :cols="12" :md="4">
      <v-select
        outlined
        dense
        clearable
        label="القسم الأساسي"
        item-value="id"
        item-text="name"
        prepend-icon="mdi-sitemap"
        :items="categories"
        :loading="loading"
        v-model="categoryId"
        @change="fetchSections($event)"
        :error-messages="errors.sub_section_id"
      ></v-select>
    </v-col>

    <!-- SECTION -->
    <v-col :cols="12" :md="4">
      <v-select
        outlined
        dense
        clearable
        label="التصنيف الرئيسي"
        item-value="id"
        item-text="name"
        prepend-icon="mdi-sitemap"
        :items="sections"
        :loading="loading"
        v-model="sectionId"
        @change="fetchSubSections($event)"
        :error-messages="errors.sub_section_id"
      ></v-select>
    </v-col>

    <!-- SUBSECTION -->
    <v-col :cols="12" :md="4">
      <v-select
        outlined
        dense
        clearable
        label="التصنيف الفرعي"
        item-value="id"
        item-text="name"
        prepend-icon="mdi-sitemap"
        :items="subSections"
        :loading="loading"
        v-model="subSectionId"
        @change="$emit('input', $event)"
        :error-messages="errors.sub_section_id"
      ></v-select>
    </v-col>
  </v-row>
</template>


<script>
export default {
  name: 'sub-sections-input',
  props: ['record', 'errors'],


  data: function () {
    return {
      categories: [],
      sections: [],
      subSections: [],

      loading: false,

      categoryId: null,
      sectionId: null,
      subSectionId: null,
    };
  },


  created() {
    this.fetchCategories();
  },


  watch: {
    'record'(record) {
      if (record && record.category && record.category.id) {
        this.categories.push(record.category);
        this.categoryId = record.category.id;
      }

      if (record && record.section && record.section.id) {
        this.sections.push(record.section);
        this.sectionId = record.section.id;
      }

      if (record && record.sub_section && record.sub_section.id) {
        this.subSections.push(record.sub_section);
        this.subSectionId = record.sub_section.id;
      }
    },

    'categoryId'(categoryId) {
      if (categoryId) {
        this.fetchSections(categoryId);
      }
    },

    'sectionId'(sectionId) {
      if (sectionId) {
        this.fetchSubSections(sectionId);
      }
    }
  },


  methods: {
    fetchCategories() {
      this.loading = true;

      this.axios.get('/admin/categories')
        .then((response) => {
          this.categories = response.data;
        })
        .finally(() => { this.loading = false; });
    },

    fetchSections(categoryId) {
      if (!Number.isInteger(categoryId)) return;
      this.loading = true;

      this.axios.get('/admin/sections', { params: { category_id: categoryId, limit: 50} })
        .then((response) => {
          this.sections = response.data.data;
          if (this.sectionId == null && this.sections.length > 0) {
            this.sectionId = this.sections[0].id;
          }
        })
        .finally(() => { this.loading = false; });
    },

    fetchSubSections(sectionId) {
      if (!Number.isInteger(sectionId)) return;
      this.loading = true;

      this.axios.get('/admin/sub-sections', { params: { section_id: sectionId, limit: 50 } })
        .then((response) => {
          this.subSections = response.data.data;
          if (this.subSectionId == null && this.subSections.length > 0) {
            this.subSectionId = this.subSections[0].id;
            this.$emit('input', this.subSectionId);
          }
        })
        .finally(() => { this.loading = false; });
    }
  }
}
</script>